const MESSAGE_VARIANT = {
  SUCCESS: "SUCCESS",
  ERROR: "ERROR",
  WARNING: "WARNING"
};

export {
  MESSAGE_VARIANT
}